import { ComponentProps, ReactNode } from 'react'
import { cn } from '~utils/cn'

type DialogContentProps = Readonly<
  ComponentProps<'div'> & {
    children: ReactNode
  }
>

const DialogContent = ({ children, className, ...props }: DialogContentProps) => {
  return (
    <div {...props} className={cn('mb-5 text-gray-700 text-body-1 lg:mb-6', className)}>
      {children}
    </div>
  )
}

export default DialogContent
